import { lightTheme } from '@/customTheme'
import Icons from '@/scenes/Editor/components/Icons'
import ButtonCustom from '@/components/ButtonCustom'
import { SHAPE } from 'baseui/button'
import { SizeButton } from '@/constants/sizeButton'

type ScrollButtonsProps = {
  handleRight: () => void
  handleLeft: () => void
  showLeft?: boolean
  showRight?: boolean
}

function ScrollButtonsLeftRight({ handleRight, handleLeft, showLeft, showRight }: ScrollButtonsProps) {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      {showLeft && <ButtonCustom
        type={SizeButton.STANDARD}
        shape={SHAPE.circle}
        onClick={handleLeft}
        style={{
          boxShadow: `0px 0px 20px 0px ${lightTheme.colors.secondaryBoxShadow}`,
          position: 'absolute',
          zIndex: 100,
          width: '40px',
          height: '40px',
          backgroundColor: lightTheme.colors.white,
          left: '24px'
        }}
      >
        <Icons.ArrowMedium direction={'left'} fill={lightTheme.colors.blackGray}/>
      </ButtonCustom>}
      { showRight && <ButtonCustom
        type={SizeButton.STANDARD}
        shape={SHAPE.circle}
        onClick={handleRight}
        style={{
          boxShadow: `0px 0px 20px 0px ${lightTheme.colors.secondaryBoxShadow}`,
          position: 'absolute',
          zIndex: 100,
          width: '40px',
          height: '40px',
          backgroundColor: lightTheme.colors.white,
          right: '24px'
        }}
      >
        <Icons.ArrowMedium direction={'right'} fill={lightTheme.colors.blackGray}/>
      </ButtonCustom>}
    </div>
  )
}

export default ScrollButtonsLeftRight
